export default __webpack_public_path__ + "static/media/sportsWeb@3x.579df73f.png";